import React from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

const ErrorMsgHook = () =>
{
	const navigate = useNavigate();

	const handleErrorMsgToast = (err) =>
	{
		if (err?.response?.data?.error)
		{
			toast.error(err?.response?.data?.error, {
				position  : toast.POSITION.TOP_RIGHT,
				className : 'toast-message'
			});
			if (err?.response?.data?.error?.toLowerCase() === 'access denied' || err?.response?.data?.error?.toLowerCase() === 'unauthorized access')
			{
				navigate('/accessdenied', {
					replace : true
				});
			}
		}
		else
		{
			toast.error(err?.message, {
				position  : toast.POSITION.TOP_RIGHT,
				className : 'toast-message'
			});
			if (err?.message?.toLowerCase() === 'access denied' || err?.message?.toLowerCase() === 'unauthorized access')
			{
				navigate('/accessdenied', {
					replace : true
				});
			}
		}
	};

	const handleErrMsg = (err) =>
	{
		if (err?.response?.data?.error)
		{
			if (err?.response?.data?.error?.toLowerCase() === 'access denied' || err?.response?.data?.error?.toLowerCase() === 'unauthorized access')
			{
				navigate('/accessdenied', {
					replace : true
				});
			}
		}
		else
			if (err?.message?.toLowerCase() === 'access denied' || err?.message?.toLowerCase() === 'unauthorized access')
			{
				navigate('/accessdenied', {
					replace : true
				});
			}
	};

	return { handleErrorMsgToast, handleErrMsg };
};

export default ErrorMsgHook;
